/**
 * Leitura de desempenho do Modo Sofá para o diagnóstico em aparelho real.
 *
 * O controle de resolução da partida já mede a taxa de quadros a cada 2 s;
 * ele escreve aqui e o selo de FPS do HUD lê. Objeto mutável de propósito:
 * publicar isso numa store re-renderizaria o React a cada medição.
 */
export const sofaPerf = {
  /** Quadros por segundo na última janela de medição (0 = ainda medindo). */
  fps: 0,
  /** Escala de resolução aplicada (1 = nativa, 0.75 = mínimo). */
  dpr: 1,
  /** Sombras ligadas (a adaptação desliga se faltar fôlego). */
  shadows: false,
};

const FPS_KEY = "rocketanks_sofa_show_fps_v1";

export function loadShowFps(): boolean {
  try {
    return localStorage.getItem(FPS_KEY) === "1";
  } catch {
    return false;
  }
}

export function saveShowFps(on: boolean) {
  try {
    localStorage.setItem(FPS_KEY, on ? "1" : "0");
  } catch {
    // navegação privada: vale só nesta sessão
  }
}
